<template>
  <GenericWrapperChart :config="config">
    <template
      v-if="showFeedbackCard"
      #afterChart
    >
      <FeedbackCard :message="'Os sentimentos dos comentários das publicações da rede social Instagram não estão inclusos nos gráficos. A API pública não fornece os comentários para análise.'" />
    </template>
  </GenericWrapperChart>
</template>

<script>
import { ExportToCsv } from 'export-to-csv';
import { json2excel } from 'js2excel';

import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';
import { generateFileName } from '@/utils';
import { FeedbackCard } from '@/components/base';

export default {
  name: 'TermsMentioned',
  components: {
    GenericWrapperChart,
    FeedbackCard,
  },
  data() {
    return {
      title: 'O que as pessoas estão falando?',
    };
  },
  computed: {
    showFeedbackCard() {
      return this.$store.state.ui.channel.toLowerCase() === 'todas';
    },
    fileName() {
      return generateFileName('O que estão falando');
    },
    overrideChartOptions() {
      return {
        exporting: {
          enabled: false,
          sourceWidth: 1250,
          filename: this.fileName,
          chartOptions: {
            chart: {
              marginRight: 20,
              marginLeft: 20,
              styleMode: true,
              borderRadius: 0,
              plotBorderWidth: 1,
              spacingBottom: 3,
              spacingLeft: 1,
              spacingRight: 1,
              height: 550,
            },
            title: {
              text: this.title,
            },
            legend: {
              itemDistance: 16,
              itemStyle: {
                fontSize: 10,
              },
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.termsMentioned.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? 'Acompanhe o termos mais mencionados nos comentários das publicações.' : '';
      const series = this.$store.state.charts.termsMentioned.data;
      const hasError = this.$store.state.charts.termsMentioned.hasError;
      const isEmpty = series.length === 0 && !isLoading && !hasError;
      const downloadList = [
        { label: 'PNG', type: 'png' },
        { label: 'PDF', type: 'pdf' },
        { label: 'CSV', type: 'csv-terms' },
        { label: 'XLS', type: 'xls-terms' },
      ];

      return {
        componentName: 'TermsMentioned',
        title,
        description,
        isLoading,
        hasError,
        isEmpty,
        onError: this.getTermsMentioned,
        requestOnMounted: this.getTermsMentioned,
        downloadMenu: {
          onSelectDownload: this.onSelectDownload,
          showDownloadMenu: true,
          downloadList,
          trackNameOnOpen: 'BM ExportTerm Graph Open',
          trackNameOnDownload: 'BM ExportTerm Graph Click',
        },
        chart: {
          type: 'PackedBubble',
          series,
          overrideChartOptions: this.overrideChartOptions,
          trackNameOnObserve: 'BM Term Graph View',
          trackNameOnLegendClick: 'BM Term LegendGraph View',
        },
      };
    },
    dataToExport() {
      const series = this.$store.state.charts.termsMentioned.data;

      return series.flatMap((item) => {
        return item.data.map(term => ({
          'Grupo': item.name,
          'Termo': term.name,
          'Quantidade': term.value,
        }));
      });
    },
  },
  methods: {
    async getTermsMentioned() {
      await this.$store.dispatch('charts/fetchTermsMentioned');
    },
    downloadCSV() {
      const options = {
        fieldSeparator: ';',
        showLabels: true,
        useKeysAsHeaders: true,
        useBom: true,
        filename: this.fileName,
      };

      new ExportToCsv(options).generateCsv(this.dataToExport);
    },
    downloadXLS() {
      json2excel({
        data: this.dataToExport,
        name: this.fileName,
      });
    },
    onSelectDownload({ typeSelected }) {
      const downloadTypes = {
        'csv-terms': this.downloadCSV,
        'xls-terms': this.downloadXLS,
      };

      if (typeSelected in downloadTypes) {
        return downloadTypes[typeSelected]();
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .tooltip-bubble {
    margin: 0;
    box-shadow: var(--ds-light-dropshadow-1);
    padding: var(--ds-spacing-stack-xs);
    border-radius: var(--ds-border-radius-sm);
    background: var(--ds-color-neutral);

    &__header {
      display: flex;
      align-items: center;
    }

    &__bottom {
      margin-top: var(--ds-spacing-stack-nano);
    }

    &__point {
      border-radius: var(--ds-border-radius-pill);
      margin-right: var(--ds-spacing-stack-nano);
      padding: var(--ds-spacing-stack-quark);
    }

    &__name {
      color: var(--ds-color-text-1);
      font-size: var(--ds-font-size-xs);
      font-weight: var(--ds-font-weight-regular);
    }

    &__value {
      color: var(--ds-color-text-1);
      font-size: var(--ds-font-size-xs);
      margin-right: var(--ds-spacing-stack-nano);
      font-weight: var(--ds-font-weight-semibold);
    }
  }
}
</style>
